import Joi from 'joi';
const imageWithMetaDataSchema = {
  path: Joi.string().allow(''),
  metadata: Joi.alternatives().try(Joi.object(), Joi.array())
};
export default imageWithMetaDataSchema;